import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { SelfServiceLayout } from './components/SelfServiceLayout';
import { ProfilePage } from './pages/ProfilePage';
import { ToastProvider } from './state/ToastContext';

export default function SelfServiceApp() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SelfServiceLayout />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="*" element={<Navigate to="/profile" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
